var _defs, _rect, _path, _path2, _line, _path3, _path4, _ellipse, _path5, _circle, _circle2, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidedrawerCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.7 17.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".calls-1,.calls-2{fill:#0070b4;}.calls-2{opacity:.15;}.calls-3{fill:none;stroke:#0070b4;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "calls-2",
    x: 3.17,
    y: 2.3,
    width: 10.49,
    height: 5.66,
    rx: 2.51,
    ry: 2.51
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "calls-3",
    d: "m2.26,7.53C2.26,3.65,4.98.5,8.35.5s6.09,3.15,6.09,7.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "calls-3",
    d: "m2.48,10.71c-1.09,0-1.98-.85-1.98-1.9s.89-1.9,1.98-1.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "calls-3",
    x1: 2.26,
    y1: 7.53,
    x2: 2.3,
    y2: 11.29
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "calls-3",
    d: "m14.44,7.52v3.74s-.22,4.28-4.72,4.86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "calls-3",
    d: "m14.21,6.8c1.09,0,1.98.85,1.98,1.9s-.89,1.9-1.98,1.9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "calls-3",
    cx: 8.36,
    cy: 16.05,
    rx: 1.32,
    ry: 1.31
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "calls-1",
    d: "m4.28,3.02c.36-1.09,6.25-4.63,8.69,0s-3.68-.39-2.77-.87.77,3.61-.73,2.14c-.68-.66-2.27-1.49-2.27-1.49h0l-.45,2.21s-2.82-.9-2.46-1.99Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "calls-1",
    cx: 6.07,
    cy: 7.71,
    r: 0.98
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "calls-1",
    cx: 10.78,
    cy: 7.73,
    r: 0.98
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "calls-1",
    d: "m6.57,12.52c1.1.56,2.5.58,3.59,0,.43-.23.05-.88-.38-.65-.32.17-.67.28-1.03.31-.31.03-.64.01-.91-.04-.23-.04-.47-.11-.69-.19-.04-.01-.07-.03-.11-.04-.04-.01.08.04-.01,0-.03-.01-.05-.02-.08-.04-.18-.09-.41-.05-.51.13-.1.17-.05.42.13.51h0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidedrawerCallIcon);
export default __webpack_public_path__ + "static/media/sidedrawer-call-icon.85817a6ba55dfa1bfdb5209bdbb3768e.svg";
export { ForwardRef as ReactComponent };